export default __webpack_public_path__ + "static/media/radio_button_empty.080ee8b1.svg";